/*
  TODO: move priceTypes to config or fetch it from backend
*/

import type { PriceType } from '@@partner:types:app'

import React from 'react'

import { SelectPicker } from 'rsuite'

const priceTypes: { value: PriceType; label: string }[] = [
  {
    value: 'piece',
    label: 'Штучный'
  },
  {
    value: 'weight',
    label: 'Весовой'
  }
]

export default function PriceTypePicker ({ value, onChange }: any) {
  return (
    <SelectPicker
      data={priceTypes}
      value={value}
      onChange={onChange}
      cleanable={false}
      searchable={false}
    />
  )
}
